import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ListaTaxasLayer from "../components/ListaTaxasLayer";
import { useTranslation } from "../i18n/I18nContext";

const TaxasPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("taxa.breadcrumb.list")} />
      <ListaTaxasLayer />
    </MasterLayout>
  );
};

export default TaxasPage;
